/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import NewContentList from "./NewContentList";

// import Event202104_contentList from "./Event202104_contentList";
// import parse from "html-react-parser";
//import '../../css/event20210317.css'
import "../../css/event210521.css";
import "../../css/event210629.css";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import moment from "moment";
// import Slider from "react-slick";
import { isMobile } from "react-device-detect";
import $ from "jquery";

class Event202106_shop extends Component {
  state = {
    eventCode: 0,
    tabIndex: 0,
  };
  componentDidMount = () => {
    this._getWindowSize();
  };
  _getWindowSize = () => {
    $("img[usemap]").rwdImageMaps();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _onBack = () => {
    const { history } = this.props;

    history.goBack();
  };

  _scroll1 = () => {
    window.scrollTo(0, 700);
  };
  _scroll2 = () => {
    window.scrollTo(0, 1600);
  };
  _scroll3 = () => {
    window.scrollTo(0, 3500);
  };

  _mscroll1 = () => {
    //alert(0)
    //document.getElementById('root').scrollTo(0, 0)
    window.scrollTo(0, 800);
  };
  _mscroll2 = () => {
    window.scrollTo(0, 200);
  };
  _mscroll3 = () => {
    window.scrollTo(0, 500);
  };
  _bang = () => {
    window.open("https://shop.aniplustv.com/cafe/25?i=0", "", "");
  };
  _king = () => {
    window.open("https://shop.aniplustv.com/cafe/24", "", "");
  };
  _mbang = () => {
    window.open("https://mshop.aniplustv.com/cafe/25?i=0", "", "");
  };
  _mking = () => {
    window.open("https://mshop.aniplustv.com/cafe/24", "", "");
  };
  _changeTab = (tabIndex) => {
    this.setState({
      tabIndex,
    });
  };
  _map = () => {
    window.open(
      "https://map.naver.com/v5/search/%EB%A9%94%EA%B0%80%EB%B0%95%EC%8A%A4%20%EC%A4%91%EC%95%99%EB%A1%9C%EC%A0%90/place/1498927482?c=14184513.9621432,4345939.5881539,15,0,0,0,dh&placePath=%3Fentry%253Dbmp",
      "",
      ""
    );
  };
  _more = () => {
    isMobile
      ? window.open("https://mshop.aniplustv.com/cafe/25?i=1", "", "")
      : window.open("https://shop.aniplustv.com/cafe/25?i=1", "", "");
  };
  render() {
    const { tabIndex } = this.state;

    return (
      <Fragment>
        <div className="event_head">
          <h3>애니플러스 지점 오픈 이벤트</h3>
          <button
            type="button"
            className="btnClose"
            onClick={this._onBack}
            style={{ pointer: "cursor" }}
          >
            <img src="img/detail_img/close_1.png" alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          <div className="event_shopOp">
            {tabIndex === 0 ? (
              <div className="sticky">
                {/*
                                <div className="linkWrap">
                                    <a href="#link1" alt="한정특전"></a>
                                    <a href="#" alt="극장특전"></a>
                                    <a href="#" alt="생일굿즈"></a>
                                    <a href="#" alt="무료배포"></a>
                                    <a href="#" alt="댓글"></a>
                                </div>
                                <img src="/img/event/event210629/quickmenu.png"/>
                                */}

                <a href="#link1">
                  <img
                    src="/img/event/event210629/quickmenu01.png"
                    alt="한정특전"
                  />
                </a>
                <a href="#link2">
                  <img
                    src="/img/event/event210629/quickmenu02.png"
                    alt="극장특전"
                  />
                </a>
                <a href="#link3">
                  <img
                    src="/img/event/event210629/quickmenu03.png"
                    alt="생일굿즈"
                  />
                </a>
                <a href="#link4">
                  <img
                    src="/img/event/event210629/quickmenu04.png"
                    alt="무료배포"
                  />
                </a>
                <a href="#link5">
                  <img
                    src="/img/event/event210629/quickmenu05.png"
                    alt="댓글"
                  />
                </a>
              </div>
            ) : null}

            <div className="tabMenu">
              <a
                onClick={() => this._changeTab(0)}
                className={tabIndex === 0 ? "active" : null}
                style={{ cursor: "pointer" }}
              >
                대전 중앙로점
                <span>7월 9일 첫 오픈 이벤트!</span>
              </a>
              <a
                onClick={() => this._changeTab(1)}
                className={tabIndex === 1 ? "active" : null}
                style={{ cursor: "pointer" }}
              >
                서울 합정점
                <span>6월 11일 리뉴얼 오픈 이벤트!</span>
              </a>
            </div>

            {tabIndex === 0 ? (
              <Fragment>
                <div className="eventMain">
                  <a
                    onClick={this._map}
                    className="location"
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src="/img/event/event210629/daejeon_btn.png"
                      alt="찾아오시는 길"
                    />
                  </a>
                  <img
                    src="/img/event/event210629/daejeon_img01.png"
                    className="img_web"
                  />
                  <img
                    src="/img/event/event210629/m_daejeon_img01.png"
                    className="img_m"
                  />
                </div>
                <div className="eventBody">
                  <div className="event">
                    {isMobile ? (
                      <Fragment>
                        <div className="link">
                          <a onClick={this._more} alt="자세히 보기"></a>
                        </div>
                        <img
                          src="/img/event/event210629/m_daejeon_imgFull.png"
                          className="img_m"
                          useMap="#FPMap1"
                        />

                        <map name="FPMap1">
                          <area
                            onClick={this._more}
                            shape="rect"
                            coords="196, 520, 465, 583"
                          />
                        </map>
                      </Fragment>
                    ) : (
                      <Fragment>
                        <div className="link">
                          <a href="#" name="link1" alt="자세히 보기"></a>
                        </div>
                        <img
                          src="/img/event/event210629/daejeon_list01.png"
                          className="img_web"
                          useMap="#FPMap0"
                        />
                        <div className="link">
                          <a href="#" name="link2" alt="자세히 보기"></a>
                        </div>
                        <img
                          src="/img/event/event210629/daejeon_list02.png"
                          className="img_web"
                        />
                        <div className="link">
                          <a href="#" name="link3" alt="자세히 보기"></a>
                        </div>
                        <img
                          src="/img/event/event210629/daejeon_list03.jpg"
                          className="img_web"
                        />
                        <div className="link">
                          <a href="#" name="link4" alt="자세히 보기"></a>
                        </div>
                        <img
                          src="/img/event/event210629/daejeon_list04.jpg"
                          className="img_web"
                        />
                        <div className="link">
                          <a href="#" name="link5" alt="자세히 보기"></a>
                        </div>

                        <map name="FPMap0">
                          <area
                            onClick={this._more}
                            shape="rect"
                            coords="1193, 616, 1459, 680"
                            style={{ cursor: "pointer" }}
                          />
                        </map>
                      </Fragment>
                    )}
                  </div>

                  {/*
                                <h2>
                                    <img src="/img/event/event210629/daejeon_tit01.png" className="img_web" alt="01 콜라보 카페"/>
                                    <img src="/img/event/event210629/m_daejeon_tit01.png" className="img_m" alt="01 콜라보 카페"/>
                                </h2>
                                <ul className="list">
                                    <li>
                                        <div className="link"><a href="#" alt="자세히 보기"></a></div>
                                        <div className="link"><a href="#" alt="자세히 보기"></a></div>
                                        <img src="/img/event/event210629/daejeon_list01.png" className="img_web"/>
                                        <img src="/img/event/event210629/m_daejeon_list01.png" className="img_m"/>
                                    </li>
                                    <li>
                                        <div className="link"><a href="#" alt="자세히 보기"></a></div>
                                        <div className="link"><a href="#" alt="자세히 보기"></a></div>
                                        <img src="/img/event/event210629/daejeon_list02.png" className="img_web"/>
                                        <img src="/img/event/event210629/m_daejeon_list02.png" className="img_m"/>
                                    </li>
                                </ul>
                                */}
                </div>
              </Fragment>
            ) : isMobile ? (
              <Fragment>
                <img
                  src="/img/event/event210602/M_event_202106.png"
                  useMap="#Map1"
                />
                <map name="Map1">
                  <area
                    onClick={this._mscroll1}
                    style={{ cursor: "pointer" }}
                    shape="rect"
                    coords="1, 533, 219, 675"
                  />
                  <area
                    onClick={this._mscroll2}
                    style={{ cursor: "pointer" }}
                    shape="rect"
                    coords="221, 535, 476, 670"
                  />
                  <area
                    onClick={this._mscroll3}
                    style={{ cursor: "pointer" }}
                    shape="rect"
                    coords="483, 538, 704, 669"
                  />
                  <area
                    onClick={this._mbang}
                    style={{ cursor: "pointer" }}
                    shape="rect"
                    coords="63, 1367, 326, 1432"
                  />
                  <area
                    onClick={this._mking}
                    style={{ cursor: "pointer" }}
                    shape="rect"
                    coords="382, 1369, 646, 1434"
                  />
                </map>
              </Fragment>
            ) : (
              <Fragment>
                <img
                  src="/img/event/event210602/W_event_202106.png"
                  useMap="#Map1"
                />
                <map name="Map1">
                  <area
                    onClick={this._scroll1}
                    style={{ cursor: "pointer" }}
                    shape="rect"
                    coords="181, 533, 623, 675"
                  />
                  <area
                    onClick={this._scroll2}
                    style={{ cursor: "pointer" }}
                    shape="rect"
                    coords="623, 534, 1085, 674"
                  />
                  <area
                    onClick={this._scroll3}
                    style={{ cursor: "pointer" }}
                    shape="rect"
                    coords="1084, 536, 1522, 674"
                  />
                  <area
                    onClick={this._bang}
                    style={{ cursor: "pointer" }}
                    shape="rect"
                    coords="379, 1318, 647, 1483"
                  />
                  <area
                    onClick={this._king}
                    style={{ cursor: "pointer" }}
                    shape="rect"
                    coords="1052, 1317, 1319, 1486"
                  />
                </map>
              </Fragment>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202106_shop));
